module.exports = __webpack_public_path__ + "static/media/EYInterstate-Light.c56b41d4.eot";